/**
 * Checks whether a datetime string is in "local time" format
 * (i.e. it does not include a timezone designator).
 *
 * Local time strings do **not** end with:
 *  - `Z` (Zulu/UTC)
 *  - a numeric offset like `+hh:mm` or `-hh:mm`
 *
 * Examples:
 *  - "2025-08-20T14:30:00"       → true  (local time, no zone)
 *  - "2025-08-20T14:30:00Z"      → false (UTC time)
 *  - "2025-08-20T14:30:00+02:00" → false (explicit offset)
 *
 * @param {string} dateString - The input datetime string to check.
 * @returns {boolean} True if the string is local time (no timezone info), false otherwise.
 */
export const isLocalTimeString = (dateString: string): boolean => {
  // If it ends with Z (UTC) or ±hh:mm (offset) → NOT local
  return !/(Z|[+-]\d{2}:\d{2})$/.test(dateString);
};
